import { defaults } from 'lodash';
import {
  APP_DEFAULT_HEIGHT,
  APP_DEFAULT_WIDTH,
  APPS_MAX_HEIGHT,
  APPS_MAX_WIDTH,
  APPS_MIN_HEIGHT,
  APPS_MIN_WIDTH,
  CollaborativeApps,
  IAppInformation,
} from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class BoardIframeConfigurations extends BoardItemConfig {
  url: string;
  sharedUrl?: string;
  title: string;
  isPrivate: boolean;
  interactionsLocked: boolean;
  appInstanceId: string;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    minWidth: APPS_MIN_WIDTH,
    maxWidth: APPS_MAX_WIDTH,
    minHeight: APPS_MIN_HEIGHT,
    maxHeight: APPS_MAX_HEIGHT,
  };

  constructor(
    configurations: Partial<BoardIframeConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    if (configurations.appInstanceId) {
      // if width, height, name, url, or resource not provided, try to set them from the app configurations
      const app: IAppInformation | undefined =
        globalCreationParams.appConfigurationService.getAppByUid(configurations.appInstanceId);
      if (app) {
        configurations.height = configurations.height ?? app.height ?? APP_DEFAULT_HEIGHT;
        configurations.width = configurations.width ?? app.width ?? APP_DEFAULT_WIDTH;
        configurations.title = configurations.title ?? app.title;
        configurations.url = configurations.url ?? app.iframeAppConfig?.defaultUrl;
      }
    }
    super(
      {
        ...BoardIframeConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const defaultIframeConfigurations = {
      title: 'IFrame',
      isPrivate: false,
      interactionsLocked: false,
      appInstanceId: CollaborativeApps.IFRAME,
      url: '',
    };

    const iframeConfigurations = defaults(configurations, defaultIframeConfigurations);

    this.url = iframeConfigurations.url;
    this.sharedUrl = iframeConfigurations.sharedUrl;
    this.title = iframeConfigurations.title;
    this.isPrivate = iframeConfigurations.isPrivate;
    this.interactionsLocked = iframeConfigurations.interactionsLocked;
    this.appInstanceId = iframeConfigurations.appInstanceId;
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): BoardIframeConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      BoardIframeConfigurations.defaultBoardItemConfigurations,
    );

    return new BoardIframeConfigurations(
      {
        ...configurations,
        url: frameItem.iframe_state?.url,
        sharedUrl: frameItem.iframe_state?.sharedUrl,
        title: frameItem.iframe_state?.title ?? 'IFrame',
        isPrivate: frameItem.isPrivate,
        interactionsLocked: frameItem.interactionsLocked,
        appInstanceId: frameItem.iframe_state?.type as CollaborativeApps,
      },
      globalCreationsParams,
    );
  }
}
